import { isPlatformBrowser } from '@angular/common';
import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../environments/environment';
import { LocalStorageService } from '../../shared/services/local-storage/local-storage.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) {
    return next(req);
  }

  const localStorageService = inject(LocalStorageService);
  const headers: Record<string, string> = {};

  const token = localStorageService.get('sToken');
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  // Chave do gateway (APIM) da API chamada; vazia, o header não é enviado.
  const subscriptionKey = chaveDaApi(req.url);
  if (subscriptionKey) {
    headers['Ocp-Apim-Subscription-Key'] = subscriptionKey;
  }

  if (Object.keys(headers).length === 0) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: headers,
    }),
  );
};

/**
 * A API de Requerimento de Benefício tem assinatura própria no APIM: chamada a `apiRequerimentoBeneficioUrl` leva a
 * chave dela; as demais, a da Parametrização (que também atende o Instituto Online).
 */
function chaveDaApi(url: string): string | undefined {
  const segmentoRequerimento = environment.apiRequerimentoBeneficioUrl?.trim();
  const ehRequerimento = !!segmentoRequerimento && url.includes(`/${segmentoRequerimento}/`);
  const chave = ehRequerimento
    ? environment.ocpApimSubscriptionKeyRequerimento
    : environment.ocpApimSubscriptionKeyParametrizacao;
  return chave?.trim();
}
